@if (mortgage) {
<ng-container *transloco="let t">
  <form #reoPropertiesForm="ngForm" novalidate id="reoPropertiesForm" name="reoPropertiesForm">
    <div class="row align-items-end" [ngClass]="{'mb-8': !isMobile}">
      @if (!isHidden('reo.typeOfProperty')) {
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.typeOfProperty')}">{{getLabel('reo.typeOfProperty', 'Property Type')}}</label>
          <select name="propertyType{{uniqueId}}" id="propertyType{{uniqueId}}" [ngClass]="{'is-invalid' : propertyType && propertyType.touched && propertyType.invalid}"
            [required]="isRequired('reo.typeOfProperty')"
            #propertyType="ngModel" class="form-select form-select-solid" [(ngModel)]="reo!.typeOfProperty"
            data-control="select2" data-hide-search="true" data-placeholder="Choose one">
            <option></option>
            @for (propertyType of propertyTypes; track propertyType.value) {
              <option #reoItem value="{{propertyType.value}}">{{propertyType.name}}</option>
            }
          </select>
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
      @if (!isHidden('reo.marketValue')) {
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.marketValue')}">{{getLabel('reo.marketValue', 'Property Value')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [required]="isRequired('reo.marketValue')"
            (change)="onPropertyValueChanged()"
            [ngClass]="{'is-invalid' : propertyValue && propertyValue.touched && propertyValue.invalid}"
            #propertyValue="ngModel" [(ngModel)]="reo!.marketValue" placeholder="" name="propertyValue{{uniqueId}}" id="propertyValue{{uniqueId}}"/>
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
    </div>
    <div class="row align-items-end" [ngClass]="{'mb-8': !isMobile}">
      @if (!isHidden('reo.purchasePrice')) {
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.purchasePrice')}">{{getLabel('reo.purchasePrice', 'Original Purchase Price')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [required]="isRequired('reo.purchasePrice')"
            (change)="onPurchasePriceChanged()"
            [ngClass]="{'is-invalid' : purchasePrice && purchasePrice.touched && purchasePrice.invalid}"
            #purchasePrice="ngModel" [(ngModel)]="reo!.purchasePrice"
            placeholder="" name="purchasePrice{{uniqueId}}" id="purchasePrice{{uniqueId}}"/>
        <div class="invalid-feedback">{{ t('wizard.reo.purchasePriceRequired') }}</div>
        </div>
      }
      @if (!isHidden('reo.dateAcquired') && !hideDateAcquired) {
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.dateAcquired')}">{{getLabel('reo.dateAcquired', 'Date Acquired')}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" autocomplete="off"
              [specialCharacters]="[ '/' ]" inputmode="numeric" [dropSpecialCharacters]="false" datePicker #dateAcquired="ngModel"
              [(ngModel)]="reo.dateAcquired"
              (ngModelChange)="onDateAcquiredChanged()"
              placeholder="" name="dateAcquired{{uniqueId}}" id="dateAcquired{{uniqueId}}" ngControl="dateAcquired" id="dateAcquired"
              [ngClass]="{'is-invalid' : dateAcquired && dateAcquired.touched && dateAcquired.invalid}"
              [required]="isRequired('reo.dateAcquired')"/>
            <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
          </div>
        </div>
      }
    </div>
    <div class="row align-items-end" [ngClass]="{'mb-8': !isMobile}">
      @if (!isHidden('reo.currentUsageType')) {
        <div class="col-md-4 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.currentUsageType')}">{{getLabel('reo.currentUsageType', 'How do you currently use this property?')}}</label>
          <select name="currentUsageType{{uniqueId}}" id="currentUsageType{{uniqueId}}" [ngClass]="{'is-invalid' : currentUsageType && currentUsageType.touched && currentUsageType.invalid}"
            [required]="isRequired('reo.currentUsageType')"
            #currentUsageType="ngModel" class="form-select form-select-solid" [(ngModel)]="reo!.currentUsageType"
            data-control="select2" data-hide-search="true" data-placeholder="Choose one">
          <option></option>
          @for (usageType of usageTypes; track usageType.value) {
            <option #reoItem value="{{usageType.value}}">{{usageType.name}}</option>
          }
        </select>
        <div class="invalid-feedback">This field is required.</div>
        </div>
      }

      <div class="col-md-4 fv-row">
        <label class="form-label mb-2 required">{{ t('wizard.reo.doYouPlanOnSelling') }}</label>
        <select name="dispositionStatus{{uniqueId}}" id="dispositionStatus{{uniqueId}}"
          [ngClass]="{'is-invalid' : willPropertyBeSoldValue && willPropertyBeSoldValue.touched && willPropertyBeSoldValue.invalid}"
          [required]="true"
          #willPropertyBeSoldValue="ngModel" class="form-select form-select-solid"
          [(ngModel)]="willPropertyBeSold"
          (ngModelChange)="onPropertyWillBeSoldChanged()"
          data-control="select2" data-hide-search="true" data-placeholder="Choose one">
        <option value="no">{{ t('common.no') }}</option>
        <option value="yes">{{ t('common.yes') }}</option>
      </select>
      <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
      </div>

      @if (!isHidden('reo.intendedUsageType') && willPropertyBeSold === 'no') {
        <div class="col-md-4 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.intendedUsageType')}">{{getLabel('reo.intendedUsageType', 'How do you plan on using this property?')}}</label>
          <select name="intendedUsageType{{uniqueId}}" id="intendedUsageType{{uniqueId}}" [ngClass]="{'is-invalid' : intendedUsageType && intendedUsageType.touched && intendedUsageType.invalid}"
            [required]="isRequired('reo.intendedUsageType')"
            #intendedUsageType="ngModel" class="form-select form-select-solid" [(ngModel)]="reo!.intendedUsageType"
            data-control="select2" data-hide-search="true" data-placeholder="Choose one">
          <option></option>
          @for (usageType of usageTypes; track usageType.value) {
            <option #reoItem value="{{usageType.value}}">{{usageType.name}}</option>
          }
        </select>
        <div class="invalid-feedback">This field is required.</div>
        </div>
      }
    </div>
    <div class="row align-items-end" [ngClass]="{'mb-8': !isMobile}">
      @if (!isHidden('reo.hazardInsurance')) {
        <div class="col-md-3 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.hazardInsurance')}">{{getLabel('reo.hazardInsurance', 'Home Insurance')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [ngClass]="{'is-invalid' : hazardInsurance && hazardInsurance.touched && hazardInsurance.invalid}"
            [required]="isRequired('reo.hazardInsurance')"
            #hazardInsurance="ngModel" [(ngModel)]="reo!.hazardInsurance" placeholder="" name="hazardInsurance{{uniqueId}}" id="hazardInsurance{{uniqueId}}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
      @if (!isHidden('reo.propertyTax')) {
        <div class="col-md-3 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.propertyTax')}">{{getLabel('reo.propertyTax', 'Property Tax')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [ngClass]="{'is-invalid' : propertyTax && propertyTax.touched && propertyTax.invalid}"
            [required]="isRequired('reo.propertyTax')"
            #propertyTax="ngModel" [(ngModel)]="reo!.propertyTax" placeholder="" name="propertyTax{{uniqueId}}" id="propertyTax{{uniqueId}}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
      @if (!isHidden('reo.hoa')) {
        <div class="col-md-3 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.hoa')}">{{getLabel('reo.hoa', 'HOA')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [ngClass]="{'is-invalid' : hoa && hoa.touched && hoa.invalid}"
            [required]="isRequired('reo.hoa')"
            #hoa="ngModel" [(ngModel)]="reo!.hoa" placeholder="" name="hoa{{uniqueId}}" id="hoa{{uniqueId}}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
      @if (!isHidden('reo.monthlyMiscExpenses')) {
        <div class="col-md-3 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.monthlyMiscExpenses')}">{{getLabel('reo.monthlyMiscExpenses', 'Monthly Misc. Expenses')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [ngClass]="{'is-invalid' : monthlyMiscExpenses && monthlyMiscExpenses.touched && monthlyMiscExpenses.invalid}"
            [required]="isRequired('reo.monthlyMiscExpenses')"
            #monthlyMiscExpenses="ngModel" [(ngModel)]="reo!.monthlyMiscExpenses" placeholder="" name="monthlyMiscExpenses{{uniqueId}}" id="monthlyMiscExpenses{{uniqueId}}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
    </div>
    @if (!isHidden('reo.amountOfMortgage')) {
      <div class="row" [ngClass]="{'mb-8': !isMobile}">
        <div class="col-md-12 fv-row">
          <reo-liens #reoLiens [mortgage]="mortgage" [reo]="reo"
            [label]="getLabel('reo.amountOfMortgage', t('wizard.reo.currentBalanceOfLiens'))"
            [required]="isRequired('reo.amountOfMortgage')">
          </reo-liens>
        </div>
      </div>
    }
    <div class="row align-items-end" [ngClass]="{'mb-8': !isMobile}">
      @if (!isHidden('reo.mortgagePayment')) {
        <div class="col-md-3 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.mortgagePayment')}">{{getLabel('reo.mortgagePayment', 'Monthly Payment')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [ngClass]="{'is-invalid' : mortgagePayment && mortgagePayment.touched && mortgagePayment.invalid}"
            [required]="isRequired('reo.mortgagePayment')"
            #mortgagePayment="ngModel"
            [(ngModel)]="reo!.mortgagePayment"
            (blur)="onMortgagePaymentChanged()"
            placeholder="" name="mortgagePayment{{uniqueId}}" id="mortgagePayment{{uniqueId}}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
      @if (!isHidden('reo.grossRentalIncome')) {
        <div class="col-md-3 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.grossRentalIncome')}">{{getLabel('reo.grossRentalIncome', 'Gross Rental Income')}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [ngClass]="{'is-invalid' : grossRentalIncome && grossRentalIncome.touched && grossRentalIncome.invalid}"
            [required]="isRequired('reo.grossRentalIncome')"
            #grossRentalIncome="ngModel" [(ngModel)]="reo!.grossRentalIncome" placeholder="" name="grossRentalIncome{{uniqueId}}" id="grossRentalIncome{{uniqueId}}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      }
    </div>
  </form>
</ng-container>
}
